import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const StickyNoteContainer = styled(motion.div)`
  position: absolute;
  bottom: 100px;
  left: 40px;
  width: 200px;
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 2px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-family: 'Comic Sans MS', cursive, sans-serif;
  font-size: 12px;
  line-height: 1.4;
  color: #92400e;
  z-index: 10;
  cursor: move;
  user-select: none;
`;

const StickyNoteHeader = styled.h4`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: bold;
  color: #92400e;
`;

const TodoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const TodoItem = styled.li`
  margin-bottom: 4px;
  position: relative;
  padding-left: 18px;
  
  &::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #f59e0b;
    font-weight: bold;
  }
  
  ${props => props.completed && `
    text-decoration: line-through;
    color: #999;
    
    &::before {
      content: '✓';
      color: #10b981;
    }
  `}
  
  ${props => props.urgent && `
    color: #dc2626;
    font-weight: bold;
    
    &::before {
      content: '🔥';
      color: #dc2626;
    }
  `}
`;

const StickyNote = () => {
  return (
    <StickyNoteContainer
      drag
      dragMomentum={false}
      dragElastic={0.1}
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.5, duration: 0.8 }}
    >
      <StickyNoteHeader>To do:</StickyNoteHeader>
      <TodoList>
        <TodoItem completed>Finish portfolio</TodoItem>
        <TodoItem completed>Deploy to Vercel</TodoItem>
        <TodoItem>Update resume</TodoItem>
        <TodoItem urgent>Apply for jobs</TodoItem>
        <TodoItem>Add Spotify integration</TodoItem>
        <TodoItem>Polish animations</TodoItem>
        <TodoItem>Complete speech-to-text app</TodoItem>
        <TodoItem>Optimize database queries</TodoItem>
      </TodoList>
    </StickyNoteContainer>
  );
};

export default StickyNote;
